
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "FinalBlock",

  props: {
    ruText: String,
    kkText: String,
    brand: String,
    currentLang: String,
    errorCode: String,
  },

  setup(props) {
    const brandType = computed(
      () => props.brand || sessionStorage.getItem("brand")
    );
    const showImage = computed(
      () => props.errorCode !== "survey-instance-finished" || false
    );
    return {
      brandType,
      showImage,
    };
  },
});
